'use client';

import { Typography } from '@musinsa/mds';
import { SERVICE, type ServiceType } from '@musinsa/packages-device-detection';
import Image from 'next/image';
import { getCdnUrl } from '../../utils/getCdnUrl';
import { ErrorContainer } from './ErrorContainer';

interface ServerErrorProps {
  onGoBack?: () => void;
  onGoHome?: () => void;
  className?: string;
  service?: ServiceType;
}

export function ServerError({ onGoBack, onGoHome, className, service }: ServerErrorProps) {
  const logo =
    service === SERVICE.MUSINSA ? (
      <Image
        src={'https://image.msscdn.net/static/assets/bi/error_logo_musinsa.png'}
        alt="무신사 로고"
        width={100}
        height={17}
      />
    ) : (
      <Image src={getCdnUrl('/images/logo/29-logo.png')} alt="29cm 로고" width={60} height={16} />
    );

  const description = (
    <Typography variant="body13pxReg" colorScheme="gray-600">
      이용에 불편을 드려 죄송합니다.
      <br />
      잠시 후 다시 이용해 주세요.
    </Typography>
  );

  const actions = [];
  if (onGoBack) {
    actions.push({ label: '이전 페이지', onClick: onGoBack });
  }
  if (onGoHome) {
    actions.push({ label: '홈으로 이동', onClick: onGoHome });
  }

  return (
    <ErrorContainer
      logo={logo}
      title="서비스 접속이 원활하지 않습니다."
      description={description}
      actions={actions}
      className={className}
    />
  );
}
